import { useEffect, useState } from "react";

import { IGroupByListColumn } from "models";

/**
 * @typedef {Object} FieldMetaT
 * @property {boolean} isUserDefinedColumn - field is a user defined column
 * @property {boolean} isOrgDefinedColumn - field is an org defined column
 * @property {boolean} isProjectDefinedColumn - field is a project defined column
 */

/**
 * Returns a meta object for the given field.
 * @return {FieldMetaT}
 */
const useField = (field: IGroupByListColumn) => {
  const [value, setValue] = useState({
    isUserDefinedColumn: false,
    isOrgDefinedColumn: false,
    isProjectDefinedColumn: false
  });

  useEffect(() => {
    const { property } = field;

    const isUserDefinedColumn =
      property?.indexOf("My_Focus_Fields") >= 0 ||
      property?.indexOf("My_Midstream_Fields") >= 0;
    const isOrgDefinedColumn =
      property?.indexOf("Org_Focus_Fields") >= 0 ||
      property?.indexOf("Org_Midstream_Fields") >= 0;
    const isProjectDefinedColumn = property?.indexOf("Project_Focus_Fields") >= 0;

    setValue(() => ({
      isUserDefinedColumn,
      isOrgDefinedColumn,
      isProjectDefinedColumn
    }));
  }, [field]);

  return value;
};

export default useField;
